ready().then(function() {

    /**
     * On mobile devices we have a shorter breadcrumbs then on desktops. Since we need a flexible solution we grab the fore-last item from the desktop breadcrumbs
     * and put in place on mobile devices
     */
    const mobileBreadcrumbs = () => {
        const breadcrumbs = $('.section-breadcrumbs');
        const breadcrumbitem = $('.section-breadcrumbs li.breadcrumb-item');
        const breadcrumbsMobile = $('.breadcrumbs-mobile ol.breadcrumb');

        if(breadcrumbs.length > 0) {
            breadcrumbsMobile.append(breadcrumbitem.eq(-2).clone());
        }
    }

    mobileBreadcrumbs();
});
